module.exports = __webpack_public_path__ + "media/PAG69-02.5fbed860.mp3";